<section>
    <div class="wrapper">
        <article class="mrt-75">
            <div class="site-list-component">
                <mat-grid-list cols="3" rowHeight="70px" class="header-grid">
                    <mat-grid-tile>
                        <span class="header">Site List</span>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field appearance="legacy" class="mat-searchbar">
                            <span matPrefix> </span>
                            <input type="text" matInput placeholder="Search" name="searchSiteFilterValue"
                                (ngModelChange)="searchTerms.next($event);" [(ngModel)]="searchSiteFilterValue">
                            <button mat-button *ngIf="searchSiteFilterValue" matSuffix mat-icon-button
                                aria-label="Clear" (click)="clearSearchFilter()">
                                <mat-icon>close</mat-icon>
                            </button>
                            <button matSuffix mat-button class="serach-button-icon"><mat-icon>search</mat-icon></button>
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="bottom-button">
                            <div class="site-dump-download">
                                <a mat-stroked-button [href]="siteDownloadUrl" class="site-download"
                                    matTooltip="Download Sites">
                                    <mat-icon aria-hidden="false" aria-label="Download Sites" class="restoreSite">arrow_downward</mat-icon>
                                </a>
                            </div>
                            <div class="site-dump-download">
                                <a mat-stroked-button  class="site-download"
                                    matTooltip="Restore Sites" (click)="restoreSite()">
                                    <mat-icon ria-hidden="false" aria-label="Restore Sites" class="restoreSite">arrow_upward</mat-icon>
                                </a>
                            </div>
                            <button mat-stroked-button class="inactive-btn" color="primary" (click)="cancelSite($event)"
                                *ngIf="editCameraConfig" matTooltip="Go to the Inactive Sites list">
                                <mat-icon aria-hidden="false" aria-label="cancel icon">cancel</mat-icon>
                                Inactive Sites
                            </button>
                            <button mat-raised-button class="movesite-btn" (click)="moveSiteDialog()"
                                *ngIf="editCameraConfig" matTooltip="Add Site to CS">
                                <mat-icon aria-hidden="false" aria-label="add icon">arrow_forward</mat-icon>
                                Move Site
                            </button>
                            <!-- <button mat-raised-button class="movesite-btn" (click)="handleDeleteSite()"
                               matTooltip="Delete Site">
                                Delete Site
                            </button> -->
                            <button mat-raised-button class="new-btn" *ngIf="isIcockpit"
                                (click)="openCockpitDialog('http://ivigiltraining.pro-vigil.info:8090/ivigil-sitessync/siteshostingserver.jsp')"
                                matTooltip="Open I-vigil Sync">
                                <img src="assets/imgs/i-sync.svg" class="img-fluid" alt="" />
                                <!-- <mat-icon aria-hidden="false" aria-label="add icon">info</mat-icon> -->
                            </button>
                            <button mat-raised-button class="new-btn" *ngIf="isIcockpit"
                                (click)="openCockpitDialog('http://workspace.pro-vigil.com:777//ivigil-shield//updatepotential.jsp')"
                                matTooltip="Open Cockpit-2">
                                <!-- <mat-icon aria-hidden="false" aria-label="add icon">info</mat-icon> -->
                                <img src="assets/imgs/info2.svg" class="img-fluid" alt="" />
                                <!-- Open Cockpit-2 -->
                            </button>
                            <button mat-raised-button class="new-btn" *ngIf="isIcockpit"
                                (click)="openCockpitDialog('http://workspace.pro-vigil.com:777/ivigil-shield/manualSyncforPortal.jsp')"
                                matTooltip="Open Cockpit-1">
                                <!-- <mat-icon aria-hidden="false" aria-label="add icon">info</mat-icon> -->
                                <img src="assets/imgs/info1.svg" class="img-fluid" alt="" />
                                <!-- Open Cockpit-1 -->
                            </button>
                        </div>
                    </mat-grid-tile>
                    <!-- <mat-grid-tile class="d-none">
                        <div class="bottom-button">
                            <button mat-raised-button class="remove-btn" (click)="removeSites()"
                                *ngIf="this.selection.selected.length != 0">
                                <mat-icon aria-hidden="false" aria-label="delete icon">delete</mat-icon>
                                Remove
                            </button>
                            <button mat-raised-button class="new-btn" (click)="addNewSite()">
                                <mat-icon aria-hidden="false" aria-label="add icon">add</mat-icon>
                                New
                            </button>
                        </div>
                    </mat-grid-tile> -->
                </mat-grid-list>
            </div>
            <div class="site-list-table">
                <div class="mat-elevation-z8 table-pagination">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortActive="created"
                        matSortDisableClear matSortDirection="desc">

                        <!-- Checkbox Column -->
                        <!-- <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef>
                                <mat-checkbox (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                                    [aria-label]="checkboxLabel()">
                                </mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="$event ? selection.toggle(row) : null"
                                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container> -->

                        <!-- Id Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef> Potential ID </th>
                            <td mat-cell *matCellDef="let element"
                                matTooltip="{{element?.farmData === null ? 'NA' :element?.farmData?.farmName}}">
                                {{element?.vtigerPotentialId}} </td>
                        </ng-container>

                        <!-- Site name Column -->
                        <ng-container matColumnDef="potentialName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Site Name </th>
                            <td mat-cell *matCellDef="let element">
                                <a (click)="handleViewOrEdit($event, element)" class="site-name-link">
                                    {{element?.potentialName}} </a>
                            </td>
                        </ng-container>

                        <!-- Site status Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                            <td mat-cell *matCellDef="let element">{{element?.status}}</td>
                        </ng-container>

                        <!-- Site farm Column -->
                        <ng-container matColumnDef="farm">
                            <th mat-header-cell *matHeaderCellDef> Farm Type </th>
                            <td mat-cell *matCellDef="let element">{{element?.farmData === null ? '-' :
                                element?.farmData?.farmName}}</td>
                        </ng-container>

                        <!-- camera count Column -->
                        <ng-container matColumnDef="cameraCount">
                            <th mat-header-cell *matHeaderCellDef matTooltip="Camera Count"> Camera </th>
                            <td mat-cell *matCellDef="let element; let i= index;"
                                (click)="openCameraListDialog(element)" class="camera-count-btn">
                                <div matBadge={{element?.cameraCount}} matBadgeOverlap="false" class="count"> </div>
                            </td>
                        </ng-container>

                        <!-- device count Column -->
                        <ng-container matColumnDef="deviceCount">
                            <th mat-header-cell *matHeaderCellDef matTooltip="Device Count"> Device </th>
                            <td mat-cell *matCellDef="let element; let i= index;" class="device-count-btn"
                                (click)="openDeviceListDialog(element)">
                                <div matBadge={{element?.deviceCount}} matBadgeOverlap="false"> </div>
                            </td>
                        </ng-container>

                        <!-- View Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef> Action </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="action-btn">
                                    <!-- <button mat-raised-button class="edit-btn" color="primary" *ngIf="element?.isNewCamServer"
                                        disabled="{{!element?.isNewCamServer}}"
                                        matTooltip="{{!element?.isNewCamServer ? 'You cannot edit old camera server' :'Edit Site'}}"
                                        (click)="handleViewOrEdit($event, element)">
                                        <mat-icon aria-hidden="false"
                                            aria-label="view icon">mode_edit_outline</mat-icon>
                                    </button>
                                    <button mat-raised-button class="edit-btn" color="primary" *ngIf="!element?.isNewCamServer"
                                        matTooltip="Move site to new camera server"
                                        (click)="handleMoveSiteToNewCS($event, element)">
                                        <mat-icon aria-hidden="false"
                                            aria-label="move site to new">arrow_right_alt</mat-icon>
                                    </button> -->
                                    <button mat-raised-button class="edit-btn" color="primary"
                                        *ngIf="element?.migrationEnabled" disabled="{{!element?.migrationEnabled}}"
                                        matTooltip="{{!element?.migrationEnabled ? 'You cannot edit old camera server' : editCameraConfig ? 'Edit Site' : 'View Site'}}"
                                        (click)="handleViewOrEdit($event, element)">
                                        <mat-icon aria-hidden="false" *ngIf="editCameraConfig"
                                            aria-label="view icon">mode_edit_outline
                                        </mat-icon>
                                        <mat-icon aria-hidden="false" *ngIf="!editCameraConfig"
                                            aria-label="view icon">visibility
                                        </mat-icon>
                                    </button>
                                    <button mat-raised-button class="edit-btn" color="primary"
                                        *ngIf="!element?.migrationEnabled" matTooltip="Move site to new camera server"
                                        (click)="handleMoveSiteToNewCS($event, element)">
                                        <mat-icon aria-hidden="false"
                                            aria-label="move site to new">arrow_right_alt</mat-icon>
                                    </button>
                                    <button mat-raised-button *ngIf="isMaskingEnabled" color="primary" class="edit-btn"
                                        style="margin-left: 5px;" matTooltip="Draw Masking" style="margin-left: 5px;"
                                        matTooltip="{{ editCameraConfig ? 'Draw Masking' : 'View Masking' }}"
                                        (click)="getMaskingDetails($event, element)">
                                        <i class="fa fa-shield fontSize_36px"></i>
                                    </button>
                                    <button mat-raised-button color="primary" class="edit-btn" style="margin-left: 5px;"
                                        matTooltip="Download xlsx file" (click)="handleDownloadSites($event, element)">
                                        <i class="fas fa-download fontSize_36px"></i>
                                    </button>
                                    <button mat-raised-button color="primary" class="edit-btn" style="margin-left: 5px;"
                                        (click)="liveView($event, element)" matTooltip="Live View">
                                        <mat-icon aria-hidden="false" aria-label="live view">play_arrow</mat-icon>
                                    </button>
                                    <button mat-raised-button *ngIf="isFootageDownloadEnabled" color="primary"
                                        class="edit-btn" style="margin-left: 5px;"
                                        (click)="handleFootageDownload($event, element)" matTooltip="Footage download">
                                        <!-- <img src="assets/imgs/icon-footage.svg" class="img-fluid" alt="" /> -->
                                        <mat-icon aria-hidden="false"
                                            aria-label="Footage download">video_library</mat-icon>
                                    </button>
                                    <button mat-raised-button  color="primary"
                                    class="edit-btn" style="margin-left: 5px;"
                                    (click)="handleDeleteSite(element)" matTooltip="Delete Site">
                                    <!-- <img src="assets/imgs/icon-footage.svg" class="img-fluid" alt="" /> -->
                                    <mat-icon aria-hidden="false"
                                        aria-label="Footage download">delete</mat-icon>
                                </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectedRow($event,row)">
                        </tr>
                    </table>
                    <div class="no_record_found_msg" *ngIf="dataSource.data.length === 0">
                        No Records Found!
                    </div>
                    <mat-paginator #paginator class="hide-ripple" [pageSizeOptions]="[10, 25, 100]"
                        [pageSize]="pageSize" [length]="totalRecords" [pageIndex]="pageNumber"
                        (page)="changePaging($event)" aria-label="Select page of users">
                    </mat-paginator>
                </div>
            </div>
        </article>
    </div>
</section>